export enum AssignmentType {
  ACTIVITY = "activity",
  CRM = "crm",
  TASK = "task",
}

export interface From {
  id: string;
  name: string;
  email: string;
}

//TODO: PROBAR COMO REACCIONA LA NOTI
export interface MessageNotification {
  id: string;
  type: string;
  timestamp: string;
  from: From;
  message: string;
  messageType: string;
}

export interface ConversationNotification {
  id: string;
  type: string;
  timestamp: string;
  contact: From;
}

export interface SocialPostNotification {
  social: string;
  status: number;
  /** Texto del post (caption) */
  content: string;
  /** Miniatura si el backend la envía */
  imageUrl?: string;
  /** Nombre de la cuenta / página en la red */
  accountName?: string;
  /** ISO u otro formato parseable por moment */
  postedAt?: string;
}

export interface ContactsImportedNotification {
  origin: string;
  amount: number;
}

export interface ImportingProcessNotification {
  status: boolean;
}

export interface NewContactsNotification {
  origin: string;
}

export interface ContactExportedNotification {
  origin: string;
  amount: number;
}

export interface TaskAssignmentNotification {
  type: AssignmentType;
  title: string;
  id: string;
}

export interface SubscriptionNotification {
  text: string;
  type: number;
}

export interface Notification {
  id: string;
  /** 0 = no leída */
  status: number;
  type: string;
  /** Si el backend envía fecha de creación de la notificación (orden/fecha de respaldo) */
  createdAt?: string;
  data:
    | MessageNotification
    | ConversationNotification
    | SocialPostNotification
    | SubscriptionNotification
    | ContactExportedNotification
    | ContactsImportedNotification
    | TaskAssignmentNotification
    | ImportingProcessNotification;
}

export interface NotificationsPayload {
  notifications: Notification[];
  count: number;
}

export interface GetNotificationsResponse {
  message: string;
  payload: NotificationsPayload;
}
